import MiCode from './code';
import { install } from '../../utils/install';
export default install(MiCode);
